import { Label } from 'ui/temp/Label'

import { ExtractFieldData, FFFieldConstraint, FFProps } from './FF.types'

import { s } from './styles'

export const FF = <TField extends FFFieldConstraint>(props: FFProps<TField>) => {
  const { label, error, errorPosition = 'bottom', required, field, input } = props
  const formErrorForThisField = field.form.state.errorMap[field.name as string]
  const finalError = error || (field.state.meta.errors || []).join(', ') || formErrorForThisField

  const onChange = (value: ExtractFieldData<TField>, meta?: unknown) => {
    const inputError = typeof meta === 'string' && meta ? meta : undefined

    field.form.setFieldMeta(field.name, (stateMeta) => ({
      ...stateMeta,
      errors: [],
      errorMap: inputError ? { onChange: inputError } : {}
    }))
    field.handleChange(value)
  }

  const onBlur = () => {
    field.handleBlur()
  }

  return (
    <s.Container data-qa={`form_${field.name}`}>
      {!!label && <Label $error={!!finalError}>{label}</Label>}
      <div style={{ display: errorPosition === 'right' ? 'flex' : 'block', alignItems: 'baseline' }}>
        {input({
          required,
          error: finalError || '',
          value: field.state.value as ExtractFieldData<TField>,
          onChange,
          onBlur
        })}
        {!!finalError && (
          <s.Error
            data-field-with-error={field.name}
            data-fieldlabel={label}
            data-fielderror={finalError}
            $error
            $position={errorPosition}
          >
            {finalError}
          </s.Error>
        )}
      </div>
    </s.Container>
  )
}
